<div *ngIf="hasAlertIcon" style="display: flex; justify-content: center">
    <img class="img-cell-rend pderr-cell-rend" src='../../assets/alert.png' matTooltip="{{tooltipText}}" matTooltipClass="multiline-tooltip" />
</div>
